import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { UserRole } from '@/types';

interface AdminRouteProps {
  children: React.ReactNode;
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuthStore();

  console.log('AdminRoute - Estado:', { isAuthenticated, isLoading, userRole: user?.role });

  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p>Carregando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('AdminRoute - Redirecionando para login');
    return <Navigate to="/login" replace />;
  }

  if (user?.role !== UserRole.ADMIN) {
    console.log('AdminRoute - Usuário não é administrador, redirecionando para dashboard');
    return <Navigate to="/dashboard" replace />;
  }

  console.log('AdminRoute - Renderizando conteúdo protegido para administrador');
  return <>{children}</>;
};
